module.exports = __webpack_public_path__ + "static/media/innovation-color.eca88e83.svg";